import { BaseService } from './base.service'

export class MedsmartService extends BaseService {

	public async createMedSmartPs(): Promise<any> {
		return super.post('/medsmart/create-ps')
		.then(data => {
			return Promise.resolve(data)
		})
		.catch((error: any) => {
			return Promise.reject("La connexion avec les serveurs Medsmart est interrompue. Veuillez réessayer plus tard.")
		})
	}


	public async medSmartPsCanTransmit(): Promise<boolean> {
		return super.get(`medsmart/ps-can-transmit`)
			.then(data => {
				return Promise.resolve(data.can_transmit)
			})
			.catch(() => {
				return Promise.reject(false)
			})
	}

	public async createMedSmartPatient(patId: string, usr_id?: string | null): Promise<any> {
		return super.post(`medsmart/create-patient/${patId}`, {usr_id: usr_id})
		.then(data => {
			return Promise.resolve(data)
		})
		.catch(() => {
			return Promise.reject("La connexion avec les serveurs Medsmart est interrompue. Veuillez réessayer plus tard.")
		})
	}

	public async medSmartPatientCanTransmit(patId: string): Promise<boolean> {
		return super.get(`medsmart/patient-can-transmit/${patId}`)
		.then(data => {
			return Promise.resolve(data.can_transmit)
		})
		.catch(() => {
			return Promise.reject(false)
		})
	}
	public async medSmartInvokePatientCallBack(patId: string): Promise<boolean>{
		return super.post(`medsmart/invoke-patient-callback-status/${patId}`)
			.then(data => {
				return Promise.resolve(data.can_transmit)
			})
			.catch(() => {
				return Promise.reject(false)
			})
	}

	public async medSmartInvokePsCallBack(): Promise<boolean>{
		return super.post(`medsmart/invoke-ps-callback-status`)
			.then(data => {
				return Promise.resolve(data.can_transmit)
			})
			.catch(() => {
				return Promise.reject(false)
			})
	}

	public async medSmartInvokeInvoiceCallBack(invId: string): Promise<boolean>{
		return super.post(`medsmart/invoke-invoice-callback-status/${invId}`)
			.then(data => {
				return Promise.resolve(data.is_bill_transmit)
			})
			.catch(() => {
				return Promise.reject(false)
			})
	}

	public async medSmartInvoiceIsTransmit(invId: string): Promise<boolean>{
		return super.get(`medsmart/invoice-is-transmit/${invId}`)
			.then(data => {
				return Promise.resolve(data.is_bill_transmit)
			})
			.catch(() => {
				return Promise.reject(false)
			})
	}

	public async medSmartInvoiceCanTransmit(invId: string): Promise<boolean>{
		return super.get(`medsmart/invoice-can-transmit/${invId}`)
			.then(data => {
				return Promise.resolve(data.can_transmit)
			})
			.catch(() => {
				return Promise.reject(false)
			})
	}

	public async medSmartInvoiceCanTransmitBySubstitute(usrId: string): Promise<boolean>{
		return super.get(`medsmart/invoice-can-transmit-by-substitute/${usrId}`)
			.then(data => {
				return Promise.resolve(data.can_transmit)
			})
			.catch(() => {
				return Promise.reject(false)
			})
	}

	public async canActiveMedSmartForSubstitute(usrId: string): Promise<boolean>{
		return super.get(`medsmart/can-activate-medsmart-for-substitute/${usrId}`)
			.then(data => {
				return Promise.resolve(data.can_activate_medsmart)
			})
			.catch(() => {
				return Promise.reject(false)
			})
	}

	public async getMedSmartNipUpdateLog(): Promise<any>{
		return super.get(`medsmart/logs`)
			.then(data => {
				return Promise.resolve(data)
			})
			.catch(() => {
				return Promise.reject("Une erreur est survenue lors de la récupération des logs MedSmart.")
			})
	}
}
